import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Scenarios from './pages/Scenarios';
import Broadcasts from './pages/Broadcasts';
import LiveChat from './pages/LiveChat';
import Settings from './pages/Settings';
import Notifications from './components/Notifications';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Notifications />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <Layout>
              <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/scenarios" element={<Scenarios />} />
                <Route path="/broadcasts" element={<Broadcasts />} />
                <Route path="/livechat" element={<LiveChat />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="*" element={<Navigate to="/dashboard" />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;